import * as defaultImport from "@splunk/react-ui/List";
export * from "@splunk/react-ui/List";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
